export const
    addEventListener = "addEventListener",
    removeEventListener = "removeEventListener",
    getAttribute = "getAttribute",
    setAttribute = "setAttribute",
    removeAttribute = "removeAttribute",
    hasAttribute = "hasAttribute",
    querySelector = "querySelector",
    querySelectorAll = querySelector + "All",
    appendChild = "appendChild",
    removeChild = "removeChild",
    createElement = "createElement",
    tagName = "tagName",
    getOwnPropertyDescriptor = "getOwnPropertyDescriptor",
    prototype = "prototype",
    __lookupGetter__ = "__lookupGetter__",
    __lookupSetter__ = "__lookupSetter__",
    DCL = "DOMContentLoaded",
    L = "load",
    EVENT_PAGESHOW = "pageshow",
    E = "error";
